import { Button, Col, Row } from "react-bootstrap";
import { ClockFill } from "react-bootstrap-icons";
import moment from "moment/min/moment-with-locales";

export default function SongHistoryRow({ item, virtualizer, virtualRow, setSelectedPlay }) {
    return (
        <Row
            key={virtualRow.key}
            data-index={virtualRow?.index}
            ref={virtualizer?.measureElement}
            style={{ transform: `translateY(${virtualRow?.start ?? 0}px)` }}
            className={`border-bottom border-ra-dark-blue align-items-stretch fs-8-xs flex-nowrap position-absolute w-xl-100 h-song-history-row ${
                [0, 6].includes(moment(item.date).day()) ? "bg-grayed-darker-out fw-bold" : ""
            }`}>
            <Col
                xs={1}
                className={`min-w-song-history-date-col text-center align-content-center position-sticky start-0 border-end bg-white${
                    [0, 6].includes(moment(item.date).day()) ? "bg-grayed-darker-out" : ""
                }`}>
                <span>{moment(item.date).format("L")}</span>
            </Col>

            {Array(24)
                .fill()
                .map((_, i) => {
                    const play = item.plays.find(x => x.hour === i);
                    return (
                        <Col xs key={i} className="d-flex align-items-center p-0 border-start border-ra-dark-blue min-w-song-history-hour-col">
                            <Button
                                variant="contained"
                                disabled={!play}
                                className="p-1 align-self-stretch align-items-center d-flex hoverable rounded-0 flex-grow-1 justify-content-center"
                                onClick={() => setSelectedPlay({ date: item.date, hour: play.hour })}>
                                <ClockFill height={20} width={20} className={`song-history-quarter${play?.quarter}`} />
                            </Button>
                        </Col>
                    );
                })}
        </Row>
    );
}
